// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__1WKJX","description":"PatientConsentPreview_description__18TfR"};